<template>
  <div>
    <HoverCard :open-delay="150" :close-delay="150">
      <HoverCardTrigger>
        <div
          class="flex items-center justify-center cursor-pointer glass-frosted size-12 rounded-8xl transition-colors"
          :class="{
            'bg-white': isAvatarHighlighted,
            'active:bg-white': !isAvatarHighlighted,
          }"
          @click="handleClick"
        >
          <img
            :src="getAvatarUrl"
            :alt="$t('home.user.avatarAlt')"
            class="size-8 transition-opacity duration-300 hover:opacity-60"
            :class="{ 'hover:opacity-100': isAvatarHighlighted }"
          />
        </div>
      </HoverCardTrigger>
      <HoverCardContent align="end" class="glass-s30 p-4 min-w-55 w-fit rounded-6xl">
        <LoggedIn
          v-if="userStore.isLoggedIn"
          @open-change-password="handleOpenChangePassword"
          @open-bind-account="handleOpenBindAccount"
          @open-bind-wx="handleOpenBindWx"
        />
        <NoLogin v-else @open-login-panel="handleOpenLoginPanel" />
      </HoverCardContent>
    </HoverCard>

    <ChangePasswordDialog v-model:open="showChangePasswordDialog" />
    <BindAccountDialog v-model:open="showBindAccountDialog" />
    <BindWechatDialog v-model:open="showBindWechatDialog" />
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue'
  import { HoverCard, HoverCardContent, HoverCardTrigger } from '@rapoo/element'
  import { useLink, useRouter } from 'vue-router'
  import { useUserStore } from '@/stores/user'
  import { getImageUrl } from '@/utils/assets'
  import { LoggedIn, NoLogin } from '@/components/user/hoverCardContent'
  import ChangePasswordDialog from '@/components/user/hoverCardContent/ChangePasswordDialog.vue'
  import BindAccountDialog from '@/components/user/hoverCardContent/BindAccountDialog.vue'
  import BindWechatDialog from '@/components/user/hoverCardContent/BindWechatDialog.vue'

  const userStore = useUserStore()
  const router = useRouter()
  const showChangePasswordDialog = ref(false)
  const showBindAccountDialog = ref(false)
  const showBindWechatDialog = ref(false)
  const isLoginPanelOpening = ref(false)

  const { isActive } = useLink({ to: { name: 'login' } })

  const isAvatarHighlighted = computed(() => {
    return (
      showChangePasswordDialog.value ||
      showBindAccountDialog.value ||
      showBindWechatDialog.value ||
      isActive.value ||
      isLoginPanelOpening.value
    )
  })

  watch(isActive, (value) => {
    if (!value) {
      isLoginPanelOpening.value = false
    }
  })

  const getAvatarUrl = computed(() => {
    const url = userStore.isLoggedIn
      ? 'header/user/avatar-loggedIn.png'
      : 'header/user/avatar-notLogin.png'
    return getImageUrl(url)
  })

  function handleOpenChangePassword() {
    showChangePasswordDialog.value = true
  }

  function handleOpenBindAccount() {
    showBindAccountDialog.value = true
  }

  function handleOpenBindWx() {
    showBindWechatDialog.value = true
  }

  function handleOpenLoginPanel() {
    isLoginPanelOpening.value = true
  }

  function handleClick() {
    if (!userStore.isLoggedIn) {
      router.push({ name: 'login' })
    }
  }
</script>
